import smoothscroll from 'smoothscroll-polyfill';
import Swiper, { Navigation } from 'swiper';
import intlTelInput from 'intl-tel-input';
import '../../../node_modules/intl-tel-input/build/js/utils';
import axios from 'axios';
import Carousel from '../components/carousel';
import { loadStripe } from '@stripe/stripe-js';
Swiper.use([Navigation]);
let stripe;
let elements;
let payVar;
var createBooking = false;
var paymentError;
var paymentErrorMessage = 'Sorry, Your payment has failed. Please try again.';

export const initCarousels = () => {
	let carousels = document.querySelectorAll('.carousel__stage');

	if (carousels) {
		let options = {
			navDots: true,
			navButtons: true,
		};

		carousels.forEach((c) => {
			new Carousel(c, options);
		});
	}
};

export const initSliders = () => {
	let sliders = document.querySelectorAll('.slider__container');

	// Create slider instances
	sliders.forEach((slider) => {
		let isMobileSlider = slider.classList.contains('slider--mob')
			? true
			: false;

		let nav = {
			nextEl: '.slider__button.slider--next',
			prevEl: '.slider__button.slider--prev',
		};

		if (slider.classList.contains('slider--hide-nav')) {
			nav = false;
		}

		// Init slider
		const swiper = new Swiper(slider, {
			preloadImages: true,
			freeMode: false,
			grabCursor: true,
			init: false,

			// observer: true,
			// observeParents: true,
			slidesPerView: 'auto',
		});

		if (isMobileSlider && window.innerWidth <= 991) {
			swiper.init();
			// console.log('mobile')
		} else if (!isMobileSlider) {
			swiper.init();
			// console.log('not mobile')
		}
	});
};

export const linkScroll = () => {
	if (document.querySelectorAll('a[href="#"]').length > 0) {
		document.querySelectorAll('a[href="#"]').forEach((link) => {
			link.addEventListener('click', function (e) {
				e.preventDefault();

				let scrollDist;
				let parent = this.closest('section');
				let currentScroll = window.scrollY;

				// if a parent section is found, scroll by the height of it
				// else scroll by the height of the viewport window
				if (parent) {
					scrollDist =
						parent.clientHeight + parent.offsetTop - currentScroll;
				} else {
					scrollDist = window.innerHeight;
				}

				// Support for all browsers
				smoothscroll.polyfill();

				// Perform scroll from current position
				window.scrollBy({
					top: scrollDist,
					behavior: 'smooth',
				});
			});
		});
	}
};

// Find distance of element from viewport edges
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return {
		element: el,
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft,
	};
}

export const animate = () => {
	// Get all elements with an animation trigger
	let sections = document.querySelectorAll('[data-anim]');

	// General animation trigger loop
	function scrollEvents() {
		// Get current scroll distance
		let currentScroll = window.scrollY;

		sections.forEach((item) => {
			let itemDist = item.offsetTop;
			let trigger = itemDist - window.innerHeight * 0.66;
			let triggerEnd = itemDist + item.clientHeight;

			// Change trigger value for footer section
			if (item.nodeName == 'FOOTER') {
				let footerHeight = item.clientHeight;
				// Animation to trigger when user has scrolled half way through footer
				trigger =
					document.querySelector('main#wrapper').clientHeight -
					(window.innerHeight - footerHeight / 2);
				if (currentScroll >= trigger) {
					item.setAttribute('data-anim', true);
				}
			} else {
				if (currentScroll >= trigger && currentScroll < triggerEnd) {
					item.setAttribute('data-anim', true);
				}
			}
		});
	}

	// Trigger elements in view on load
	scrollEvents();

	// Listen for elements coming in to view
	window.addEventListener('scroll', function () {
		scrollEvents();
	});
	// Adjust on window resize
	window.addEventListener('resize', function () {
		scrollEvents();
	});
};

export const mobileMenu = () => {
	function toggleMobileMenu(event) {
		event.preventDefault();
		let active = document.body.classList.contains('mobile--active');
		if (active) {
			document.body.classList.add('mobile--closing');
			setTimeout(function () {
				document.body.classList.remove('mobile--active');
				document.body.classList.remove('mobile--closing');
			}, 500);
		} else {
			document.body.classList.add('mobile--active');
		}
	}

	let mobileToggle = document.querySelector('.header__mobile-toggle');
	if (mobileToggle) {
		mobileToggle.addEventListener('click', toggleMobileMenu);
	}
};

export const header = () => {
	function headerActive() {
		let currentScroll = window.scrollY;
		let header = document.querySelector('header#main');
		let body = document.body;

		// Add active class on scroll
		if (currentScroll >= header.clientHeight) {
			body.classList.add('header--active');
		} else {
			body.classList.remove('header--active');
		}
	}

	headerActive();
	addEventListener('scroll', headerActive);
};

export const headerMenuDot = () => {
	let headerMenu = document.querySelector('.header__menu-wrap');

	if (headerMenu) {
		let menuItems = headerMenu.querySelectorAll('li a');
		let currentItem = headerMenu.querySelector('li.current-menu-item');
		let dot = headerMenu.querySelector('.header__dot');
		let dotStart = itemPos(menuItems[0]);

		if (currentItem) {
			dotStart = itemPos(currentItem);
		}

		// init pos
		dot.style.left = dotStart + 'px';

		function itemPos(el) {
			return el.offsetLeft + el.getBoundingClientRect().width / 2;
		}

		function moveDot(dist) {
			if (dist) dot.style.transform = 'translateX(' + dist + 'px)';
			else dot.style.transform = 'translateX(0px)';
		}

		menuItems.forEach((item) => {
			item.addEventListener('mouseover', function () {
				if (
					!item.parentElement.classList.contains('current-menu-item')
				) {
					// Set active class
					headerMenu.classList.add('header--active');
					setTimeout(function () {
						headerMenu.classList.remove('header--active');
					}, 500);
				}
			});

			item.onmouseover = function () {
				let dist = itemPos(item) - dotStart;
				moveDot(dist);
			};
		});

		headerMenu.onmouseleave = function () {
			if (currentItem) moveDot();
		};
	}
};

export const credit = () => {
	console.log(
		'%c  Built by Yeah Right | https://yeahright.co  ',
		'background-color:#000f7c; color: #9ad5ff; font-size:10px; padding:8px 4px; border-radius:6px;'
	);
};

export const landingButtons = () => {
	let buttons = document.querySelectorAll('.btn--widget');

	buttons.forEach((button) => {
		button.onclick = function (e) {
			e.preventDefault();
		};
	});
};

export const modalButtons = () => {
	let buttons = document.querySelectorAll('[data-modal]');
	buttons.forEach((button) => {
		button.onclick = function (e) {
			e.preventDefault();
			let type = button.getAttribute('data-modal');
			document.body.classList.toggle('modal--active-' + type);
		};
	});
};

export const modalKill = () => {
	window.addEventListener('keydown', function (e) {
		if (e.key == 'Escape') {
			document.body.classList.forEach((c) => {
				if (c.startsWith('modal--active-'))
					this.document.body.classList.remove(c);
			});
		}
	});
};

export const phoneFields = () => {
	const telFields = document.querySelectorAll('input[type="tel"]');
	telFields.forEach((field) => {
		let intField = intlTelInput(field, {
			autoInsertDialCode: true,
			nationalMode: false,
			showSelectedDialCode: true,
			preferredCountries: ['GB'],
			hiddenInput: function (phone) {
				return 'phone_full';
			},
			utilsScript: '../../../node_modules/intl-tel-input/build/js/utils',
		});
		intField.getNumber();
	});
};

export const loadStripeForm = async () => {
	if (
		document.querySelector('form#confirm') &&
		document.querySelector('form#confirm #payment')
	) {
		let publishKey = document.querySelector(
			'form#confirm input[name="pk"]'
		).value;
		let clientSecret = document.querySelector(
			'form#confirm input[name="pi"]'
		).value;
		stripe = await loadStripe(publishKey);
		elements = stripe.elements({
			clientSecret: clientSecret,
		});
		const paymentElement = elements.create('payment');
		paymentElement.mount('#payment');
	}
};

export const handleStripePayment = async () => {
	try {
		const { error, paymentIntent } = await stripe.confirmPayment({
			elements,
			confirmParams: {
				return_url: window.location.href.split('?')[0],
				// return_url: window.location.href,
				payment_method_data: {
					billing_details: {
						name:
							document.querySelector(
								'form#confirm input[name="first_name"]'
							).value +
							' ' +
							document.querySelector(
								'form#confirm input[name="last_name"]'
							).value,
						email: document.querySelector(
							'form#confirm input[name="email"]'
						).value,
					},
				},
			},
			redirect: 'if_required',
		});

		if (error) {
			paymentError = paymentErrorMessage;
		} else if (paymentIntent && paymentIntent.status === 'succeeded') {
			paymentError = null;
			payVar =
				'&payment_intent=' +
				paymentIntent.id +
				'&payment_intent_client_secret=' +
				paymentIntent.client_secret +
				'&redirect_status=' +
				paymentIntent.status;
			createBooking = true;
		} else {
			paymentError = paymentErrorMessage;
		}
	} catch (error) {
		paymentError = paymentErrorMessage;
	}
};

export const handleFormSubmission = () => {
	let forms = document.querySelectorAll('form.form--ajax');

	async function submitForm(e, stripe) {
		let currentForm = e.target;
		e.preventDefault();

		let forceAction = currentForm.classList.contains('form--force-action')
			? true
			: false;

		let data = new FormData(currentForm);
		let action = '/wp-admin/admin-ajax.php';
		document.getElementById('overlaySpinner').style.opacity = "1";

		if (forceAction) {
			action = currentForm.getAttribute('action');
		}

		currentForm.classList.add('form--active');

		let headerConfig = {
			headers: {
				'X-Requested-With': 'xmlhttprequest',
			},
		};

		// Attempt payment before proceeding with event booking
		if (stripe) {
			let error = null;
			error = await handleStripePayment();
			if (error) {
				// Output Stripe Error
				currentForm.querySelector('.form__response').innerHTML =
					error.message;
				currentForm.classList.remove('form--active');
				currentForm.classList.add('form--notify');
				document.getElementById('overlaySpinner').style.opacity = "0";
				// console.log('Error ' + error.message)
				return;
			} else if (paymentError) {
				// Catch other errors
				currentForm.querySelector('.form__response').innerHTML =
					paymentError;
				currentForm.classList.remove('form--active');
				currentForm.classList.add('form--notify');
				// console.log('Custom: ' + paymentError)
				document.getElementById('overlaySpinner').style.opacity = "0";

				return;
			}
		}
		if (createBooking || !stripe) {

			let logUuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
				(+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
			)
			data.set('logUuid', logUuid)
			// No prepayment or success on Stripe
			axios
				.post(action, data, headerConfig)
				.then(function (response) {
					// Display message
					// currentForm.querySelector('.form__response').innerHTML =
					// 	response.data;
					// console.log('API Error ' + response)
					currentForm.classList.remove('form--active');
					currentForm.classList.add('form--notify');
					// console.log('URL BOOK - ' + response.data);
					if (payVar) {
						if (response.data) {
							window.location.href = window.location.href.split('&')[0] + '&logUuid=' + logUuid +  payVar + '&booking=' + response.data;
						} else {
							window.location.href = window.location.href.split('&')[0] +  '&logUuid=' + logUuid + payVar;
						}
					} else {
						if (response.data) {
							// Only for non prepayment bookings
							window.location.href = window.location.href.split('&')[0] + '&logUuid=' + logUuid + '&payment_intent=none&redirect_status=succeeded&booking=' + response.data;
						}
					}
				})
				.catch(function (error) {
					// console.log(error);
					// output warning
					currentForm.querySelector('.form__response').innerHTML =
						error.response.data;
					currentForm.classList.remove('form--active');
					currentForm.classList.add('form--notify');
					document.getElementById('overlaySpinner').style.opacity = "0";
				});
		}
	}

	// listen for form submissions
	forms.forEach((form) => {
		// Listen for submissions
		form.addEventListener('submit', (e) => {
			let stripe = false;
			if (form.id == 'confirm' && form.querySelector('#payment')) {
				stripe = true;
			}
			submitForm(e, stripe);
		});
	});
};

export const handleBookOption = () => {
	let bookForm = document.querySelector('.book__form-wrap form');
	if (bookForm) {
		document.querySelector('.book').addEventListener('change', () => {
			setSlotInfo();
		});
		let options = bookForm.querySelectorAll('.book__form-row');
		let slots = bookForm.querySelectorAll('.book__slot');

		if (options) {
			options.forEach((option) => {
				let input = option.querySelector('.book__field-value input');
				let buttons = option.querySelectorAll('.btn--iter');

				buttons.forEach((btn) => {
					btn.addEventListener('click', function (e) {
						e.preventDefault();
						if (this.classList.contains('btn--plus')) {
							input.stepUp();
						}
						if (this.classList.contains('btn--minus')) {
							input.stepDown();
						}
					});
				});
			});
		}

		function setSlotInfo(
			eventName,
			price,
			timestamp,
			id,
			shiftid,
			dates,
			upgrades
		) {
			let bookDetails = document.querySelector('.book__form-details');
			let bookNav = document.querySelector('.book__form-nav') || false;
			let bookIDField = document.querySelector('.book__form-id');
			let bookShiftIDField = document.querySelector(
				'.book__form-shift-id'
			);

			if (bookDetails) {
				if (timestamp) {
					let scrollDist = bookDetails.offsetTop;
					window.scrollTo({
						top: scrollDist < 0 ? 0 : scrollDist,
					});
				}

				let bookEvent = bookDetails.querySelector('.book__event span');
				let bookEventField =
					bookDetails.querySelector('.book__event input');
				let bookTime = bookDetails.querySelector('.book__time span');
				let bookTimeI = bookDetails.querySelector('.book__time input');
				let bookUpgradeCatsI = bookDetails.querySelector(
					'.book__upgrade-cats input'
				);
				let bookPrice = bookDetails.querySelector('.book__price span');
				let bookPriceI =
					bookDetails.querySelector('.book__price input');
				let bookDate = bookDetails.querySelector('.book__date select');
				let bookPriceField =
					bookDetails.querySelector('.book__price input');
				let bookQty = bookDetails.querySelector(
					'.book__qty input[type="number"]'
				);
				let bookSubtotal = bookDetails.querySelector(
					'.book__subtotal span'
				);
				let bookProceed = bookNav
					? bookNav.querySelector('.book__proceed')
					: false;

				let date = new Date(timestamp);

				if (bookTime && date.toLocaleTimeString() !== 'Invalid Date') {
					bookTime.innerHTML = date
						.toLocaleTimeString()
						.substring(0, date.toLocaleTimeString().length - 3);
					bookTimeI.value = bookTime.innerHTML;
				}

				if (bookEvent && eventName) {
					bookEvent.innerHTML = eventName;
					bookEventField.value = eventName;
				}

				if (bookPrice && price) {
					let priceFormat = new Intl.NumberFormat('en-GB', {
						style: 'currency',
						currency: 'GBP',
					}).format(price);
					bookPrice.innerHTML = priceFormat;
					bookPriceI.value = priceFormat;
					bookPriceField.value = price;
				}

				if (bookIDField && id) {
					bookIDField.value = id;
				}

				if (bookShiftIDField && shiftid) {
					bookShiftIDField.value = shiftid;
				}

				if (dates && bookDate) {
					let options = '';
					JSON.parse(dates).forEach((date) => {
						let dateString = new Date(date).toLocaleDateString(
							'en-GB',
							{
								weekday: 'long',
								year: 'numeric',
								month: 'long',
								day: 'numeric',
							}
						);
						options +=
							'<option value="' +
							date +
							'">' +
							dateString +
							'</option>';
					});
					bookDate.innerHTML = options;
				}

				if (upgrades && bookUpgradeCatsI) {
					bookUpgradeCatsI.value = upgrades;
				}

				if (bookSubtotal && bookQty && bookPrice && price) {
					let priceFormat = new Intl.NumberFormat('en-GB', {
						style: 'currency',
						currency: 'GBP',
					}).format(parseFloat(price) * bookQty.value);
					bookSubtotal.innerHTML = priceFormat;
					bookQty.onchange = () => {
						let priceFormat = new Intl.NumberFormat('en-GB', {
							style: 'currency',
							currency: 'GBP',
						}).format(parseFloat(price) * bookQty.value);
						bookSubtotal.innerHTML = priceFormat;
					};
				}

				//Enable proceed
				if (bookProceed) bookProceed.disabled = false;
			}
		}

		if (slots) {
			slots.forEach((slot) => {
				slot.onclick = function () {
					let event = slot.getAttribute('data-event');
					let timestamp = slot.getAttribute('data-timestamp');
					let id = slot.getAttribute('data-location');
					let shiftid = slot.getAttribute('data-shift');
					let price = slot.getAttribute('data-price');
					let dates = slot.getAttribute('data-dates');
					let upgrades = slot.getAttribute('data-upgrades');
					setSlotInfo(
						event,
						price,
						timestamp,
						id,
						shiftid,
						dates,
						upgrades
					);
				};
			});
		}
	}
};

export const handleMenus = () => {
	let menus = document.querySelector('.menus');

	function hideMenus() {
		let menuTitles = menus.querySelectorAll('.menu__title');
		let menuBodies = menus.querySelectorAll('.menu__body');
		menuTitles.forEach((title) => {
			title.classList.remove('menu--active');
		});
		menuBodies.forEach((body) => {
			body.classList.remove('menu--active');
		});
	}

	function hideSections() {
		let sectionTitles = menus.querySelectorAll(
			'.menu__body.menu--active .menu__section'
		);
		let sectionBodies = menus.querySelectorAll(
			'.menu__body.menu--active .menu__items-wrap'
		);
		sectionTitles.forEach((title) => {
			title.classList.remove('item--active');
		});
		sectionBodies.forEach((body) => {
			body.classList.remove('item--active');
		});
	}

	function handleMenuToggle(menuIndex) {
		if (menuIndex) {
			let menuTitle = menus.querySelector(
				'.menu__title[data-index="' + menuIndex + '"]'
			);
			let menuBody = menus.querySelector(
				'.menu__body[data-index="' + menuIndex + '"]'
			);

			hideMenus(); // hide all menus

			menuTitle.classList.add('menu--active');
			menuBody.classList.add('menu--active');
		}
	}

	function handleSectionToggle(sectionIndex) {
		if (sectionIndex) {
			let menuSection = menus.querySelector(
				'.menu__body.menu--active .menu__section[data-index="' +
					sectionIndex +
					'"]'
			);
			let menuItems = menus.querySelector(
				'.menu__body.menu--active .menu__items-wrap[data-index="' +
					sectionIndex +
					'"]'
			);

			hideSections(); // hide all sections

			menuSection.classList.add('item--active');
			menuItems.classList.add('item--active');
		}
	}

	if (menus) {
		let menuSelectTitles = menus.querySelectorAll(
			'.menu__select .menu__title'
		);
		let menuSectionTitles = menus.querySelectorAll(
			'.menu__sections .menu__section'
		);
		// Set menu
		menuSelectTitles.forEach((title) => {
			title.addEventListener('click', function () {
				let menuIndex = title.getAttribute('data-index');
				handleMenuToggle(menuIndex);
			});
		});

		// Set section
		menuSectionTitles.forEach((title) => {
			title.addEventListener('click', function () {
				let sectionIndex = title.getAttribute('data-index');
				handleSectionToggle(sectionIndex);
			});
		});
	}
};

export const handleSignupModal = () => {
	let signupButtons = document.querySelectorAll('a[href="#signup"]');

	if (signupButtons) {
		signupButtons.forEach((btn, i) => {
			btn.id = 'sr-signup-' + i;

			btn.addEventListener('click', (e) => {
				e.preventDefault();
			});

			window.SevenroomsWidget.init({
				venueId: 'ballerz',
				type: 'subscription',
				triggerId: btn.id,
				styleButton: false,
			});
		});
	}
};

// Confirmation Form Validation
window.onload = function () { 
	var form = document.getElementById('confirm');
	// if (form && form.elements.length > 0) {
	if (form && form.elements) {
			// form.button.onclick = function (){
		for (var i = 0; i < form.elements.length; i++) {
			if (
				form.elements[i].value === '' &&
				form.elements[i].hasAttribute('required')
			) {
				//   alert('There are some required fields!');
				return false;
			} else {
				// form.submit.required = false;
				if (document.getElementById('BtnConfirm')) {
					document.getElementById('BtnConfirm').disabled = false;
				}
			}
		}
	}
	//   form.submit();
	// };
}; 

// Spinner - keeping this away from any booking code...
if (document.getElementById('reservation_hold')) {
	document.getElementById('reservation_hold').addEventListener("submit", function() {
		document.getElementById('overlaySpinner').style.opacity = "1";
		// console.log('spin active')
	});
}


// Reservation holds
if (document.getElementById('countdown')) {
	document.getElementById('countdown').innerHTML = '5:00';
	startTimer();

	function startTimer() {
		var presentTime = document.getElementById('countdown').innerHTML;
		var timeArray = presentTime.split(/[:]+/);
		var m = timeArray[0];
		var s = checkSecond(timeArray[1] - 1);
		if (s == 59) {
			m = m - 1;
		}
		if (m < 0) {
			return;
		}
		if (m == 0 && s == 0) {
			document.getElementById('countdownHolder').innerHTML =
				'Sorry, your reservation hold has expired!<br><br>';
			document.getElementById('countdownHolder').innerHTML +=
				'<a href="' +
				window.location.href.split('&')[0] +
				'">Click here</a> to start again.';
			document.getElementById('confirm').style.display = 'none';
		} else {
			document.getElementById('countdown').innerHTML = m + ':' + s;
			setTimeout(startTimer, 1000);
		}
	}

	function checkSecond(sec) {
		if (sec < 10 && sec >= 0) {
			sec = '0' + sec;
		} // add zero in front of numbers < 10
		if (sec < 0) {
			sec = '59';
		}
		return sec;
	}
}

// Reservation hold > Fail
if (document.getElementById('ReservationFail')) {
	document.getElementById('ReservationFail').innerHTML =
	'Sorry, your reservation hold has been unsuccessful.<br><br>';
	document.getElementById('ReservationFail').innerHTML +=
	'<a href="' +
	window.location.href.split('&')[0] +
	'">Click here</a> to start again.';	
}